export default "__VITE_ASSET__ff8ba8e9__"